import { Injectable } from '@angular/core';
import { Mutation, gql } from 'apollo-angular';

import { ExpireBookingSession } from './__generated__/expire-booking-session-graphql.service.types';

@Injectable({
  providedIn: 'root',
})
export class ExpireBookingSessionGraphQL extends Mutation<ExpireBookingSession> {
  document = gql`
    mutation ExpireBookingSession {
      expireBookingSession(input: {}) {
        success
        errors
      }
    }
  `;
}
